import { forwardRef, useCallback } from 'react';

import { BaseComponent } from '../BaseComponent.tsx';
import type { IconFilledProps, IconRender } from '../types.ts';

const Clear = forwardRef<SVGSVGElement | null, IconFilledProps>(function Clear({ filled, dataTestId, ...props }, ref) {
  // eslint-disable-next-line no-restricted-syntax
  const iconRender = useCallback<IconRender>(
    (color: string) => (
      <>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M12 20.5C16.6944 20.5 20.5 16.6944 20.5 12C20.5 7.30558 16.6944 3.5 12 3.5C7.30558 3.5 3.5 7.30558 3.5 12C3.5 16.6944 7.30558 20.5 12 20.5ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z'
          fill={filled ? 'transparent' : color}
        />
        <path
          d='M14.6162 15.6768C14.8114 15.872 15.128 15.872 15.3233 15.6768L15.6768 15.3232C15.8721 15.128 15.8721 14.8114 15.6768 14.6161L13.0607 12L15.6768 9.38388C15.8721 9.18862 15.8721 8.87204 15.6768 8.67678L15.3233 8.32322C15.128 8.12796 14.8114 8.12796 14.6162 8.32322L12.0001 10.9393L9.38394 8.32322C9.18868 8.12796 8.8721 8.12796 8.67683 8.32322L8.32328 8.67678C8.12802 8.87204 8.12802 9.18862 8.32328 9.38388L10.9394 12L8.32328 14.6161C8.12802 14.8114 8.12802 15.128 8.32328 15.3232L8.67683 15.6768C8.8721 15.872 9.18868 15.872 9.38394 15.6768L12.0001 13.0607L14.6162 15.6768Z'
          fill={filled ? 'transparent' : color}
        />
        {/* filled */}
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM14.6162 15.6768L12.0001 13.0607L9.38394 15.6768C9.18868 15.872 8.8721 15.872 8.67683 15.6768L8.32328 15.3232C8.12802 15.128 8.12802 14.8114 8.32328 14.6161L10.9394 12L8.32328 9.38388C8.12802 9.18862 8.12802 8.87204 8.32328 8.67678L8.67683 8.32322C8.8721 8.12796 9.18868 8.12796 9.38394 8.32322L12.0001 10.9393L14.6162 8.32322C14.8114 8.12796 15.128 8.12796 15.3233 8.32322L15.6768 8.67678C15.8721 8.87204 15.8721 9.18862 15.6768 9.38388L13.0607 12L15.6768 14.6161C15.8721 14.8114 15.8721 15.128 15.6768 15.3232L15.3233 15.6768C15.128 15.872 14.8114 15.872 14.6162 15.6768Z'
          fill={filled ? color : 'transparent'}
        />
      </>
    ),
    [filled],
  );
  return <BaseComponent ref={ref} dataTestId={dataTestId ?? 'clear-icon-svg'} iconRender={iconRender} {...props} />;
});

export default Clear;
